export enum TFCOLORS {
  success = "#448D54",
  error = "#AA1212",
}
